export default "__VITE_ASSET__paUV9aE7__"